import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { PoolerJobsService } from '../../services/pooler/pooler-jobs.service';

@Component({
  selector: 'app-hide-all-jobs-button',
  templateUrl: './hide-all-jobs-button.component.html',
  styleUrls: ['./hide-all-jobs-button.component.scss'],
})
export class HideAllJobsButtonComponent {
  readonly hideAllJobsLoading$: Observable<boolean> =
    this.poolerJobsService.hideAllJobsLoading$;

  constructor(private poolerJobsService: PoolerJobsService) {}

  onClick(): void {
    this.poolerJobsService.runHideAllJobs();
  }
}
